var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvarageTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA1\xD0\xB5\xD1\x80\xD0\xB5\xD0\xB4\xD0\xBD\xD1\x96\xD0\xB9 \xD1\x82\xD0\xB5\xD0\xBC\xD0\xBF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 184",
    d: "M23 16C23 17.3845 22.5895 18.7378 21.8203 19.889C21.0511 21.0401 19.9579 21.9373 18.6788 22.4672C17.3997 22.997 15.9922 23.1356 14.6344 22.8655C13.2765 22.5954 12.0292 21.9287 11.0503 20.9497C10.0713 19.9708 9.4046 18.7235 9.1345 17.3656C8.86441 16.0078 9.00303 14.6003 9.53284 13.3212C10.0627 12.0421 10.9599 10.9489 12.111 10.1797C13.2622 9.41054 14.6155 9 16 9L16 16H23Z",
    stroke: "#444F60",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 185",
    cx: 25.5,
    cy: 25.5,
    r: 4.5,
    fill: "#F1F2F4",
    stroke: "#444F60",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 9V16H23",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.4873 3.27499L28.7248 7.51249",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.2749 7.51249L7.5124 3.27499",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23 25.5H24.6562L25.125 24.4688L25.875 26.4375L26.3438 25.5H28",
    stroke: "#444F60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvarageTemp);
export default __webpack_public_path__ + "static/media/avarageTemp.0c6292242545cfd7de8f240e8186d57b.svg";
export { ForwardRef as ReactComponent };